import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['remoteBalanceContainer']

  toggleRemoteBalanceInput (e) {
    this.remoteBalanceContainerTarget.classList.toggle('hidden')
  }
}
